/* gx-cart-v2.js — 100X Equine slide-out cart, v2.

   REBUILT 2026-08-04 against the approved design source (design-source/cart/*.html).
   Pairs with sections/gx-cart-v2.liquid + assets/gx-cart-v2.css.

   ONE DRAWER, TWO PATHS, decided from the cart itself:
     ANY line on a selling plan -> data-mode="sub"
     otherwise                  -> data-mode="onetime"
   There is no third "mixed" state. The live discount is appliesOnSubscription:false, which
   suppresses the order discount outright on any cart holding a subscription rather than
   narrowing it to the one-time portion (verified against the live store 2026-08-04). So a
   cart with a subscription in it earns nothing, and showing it a reward ladder would promise
   money checkout will never take off. Per-line affordances still follow the LINE though: a
   one-time item sitting in such a cart keeps its stepper and its remove button.

   Nothing here hardcodes a price. Line prices come from /cart.js, cross-sell prices from
   /products/{handle}.js. The only hardcoded commercial numbers are the reward tiers. */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ *
   * TIER TABLE — the single source of truth for the reward.
   *
   * 5% at $110, 10% at $200, 15% at $350. Cents, because every number the
   * Cart AJAX API returns is in cents and converting first introduces float
   * error at exactly the boundary the customer is watching.
   *
   * DELIBERATELY NOT A THEME SETTING. A Shopify Function enforces the money
   * at checkout; this table only draws it. Doug confirmed these figures twice
   * (2026-08-03, 2026-08-04). Design exports carrying $100/$200/$300 are the
   * wrong half — correct the design, never this table.
   *
   * The bar prints NO thresholds, so a label can no longer drift from what is
   * charged. The table behind it still has to be right.
   * ------------------------------------------------------------------ */
  var TIERS = [
    { pct: 5,  min: 11000 },
    { pct: 10, min: 20000 },
    { pct: 15, min: 35000 }
  ];

  /* Cross-sell. Handles and copy only — every price is fetched live.
     PAIRS drives what to suggest for what is already in the cart; RECS is the
     fallback order when nothing matches. */
  var PAIRS = {
    'gut-x-50-savings':               ['osteo-max', 'max_calm'],
    'osteo-max':                      ['gut-x-50-savings', 'joint-flex-50-savings-halloween-sale'],
    'joint-flex-50-savings-halloween-sale': ['gut-x-50-savings', 'hydra_max'],
    'max_calm':                       ['gut-x-50-savings'],
    'hydra_max':                      ['gut-x-50-savings', 'joint-flex-50-savings-halloween-sale'],
    'regen-x-up-to-50-savings':       ['gut-x-50-savings', 'osteo-max']
  };
  var RECS = ['gut-x-50-savings', 'osteo-max', 'joint-flex-50-savings-halloween-sale',
              'regen-x-up-to-50-savings', 'max_calm', 'hydra_max'];
  /* Category lines are brand copy, not catalogue data: Shopify's product_type is
     "Horse Care Supplements" for all of them, so it cannot drive this. */
  var CATS = {
    'gut-x-50-savings': 'Gut &amp; Immune Support',
    'osteo-max': 'Joint, Soft Tissue &amp; Bone',
    'joint-flex-50-savings-halloween-sale': 'Joint &amp; Mobility',
    'regen-x-up-to-50-savings': 'Topline &amp; Muscle',
    'max_calm': 'Focus &amp; Temperament',
    'hydra_max': 'Hydration &amp; Electrolytes'
  };
  /* Colic Surgery Coverage is conditional on Gut X being on subscription. */
  var COVERAGE_HANDLE = 'gut-x';

  /* ---------- guards: never two carts, never a double add ---------- */

  var root = document.querySelector('[data-gxc2-drawer]');
  if (!root) return;

  if (document.querySelector('[data-gx-drawer]') && !window.GX_CART_V2_FORCE) {
    if (window.console && console.warn) {
      console.warn('[gx-cart-v2] v1 drawer (gutx-cart.liquid) is on this page — standing down to avoid double add-to-cart. Set window.GX_CART_V2_FORCE = true to run both anyway.');
    }
    return;
  }

  // data-calc-only = Quick Calculator-only mount (2026-08-13): renders no cart drawer, so it
  // is not the double-drawer this removal exists for. Remove only full cart mounts.
  var reactCartRoot = document.getElementById('gx-bundle-root');
  if (reactCartRoot && !reactCartRoot.hasAttribute('data-calc-only')) reactCartRoot.remove();

  var ocuMode = root.getAttribute('data-gxc2-ocu-mode') || 'own';
  function deferToOcu() { return ocuMode === 'defer' && !!document.querySelector('.ocu-cart-drawer'); }

  window.__gxCartModule = true;

  /* ---------- element refs ---------- */

  var scrim     = document.querySelector('[data-gxc2-scrim]');
  var linesEl   = root.querySelector('[data-gxc2-lines]');
  var rowsEl    = root.querySelector('[data-gxc2-rows]');
  var alsoEl    = root.querySelector('[data-gxc2-also]');
  var swapEl    = root.querySelector('[data-gxc2-swap]');
  var emptyEl   = root.querySelector('[data-gxc2-empty]');
  var countEl   = root.querySelector('[data-gxc2-count]');
  var addmoreEl = root.querySelector('[data-gxc2-addmore]');
  var tierEl    = root.querySelector('[data-gxc2-tier]');
  var nudgeEl   = root.querySelector('[data-gxc2-nudge]');
  var segEls    = root.querySelectorAll('[data-gxc2-track] .gx-c2-seg');
  var discEl    = root.querySelector('[data-gxc2-disc]');
  var shipEl    = root.querySelector('[data-gxc2-ship]');
  var totEl     = root.querySelector('[data-gxc2-tot]');
  var totLblEl  = root.querySelector('[data-gxc2-tot-label]');
  var totValEl  = root.querySelector('[data-gxc2-tot-value]');
  var saveEl    = root.querySelector('[data-gxc2-save]');
  var saveTxtEl = root.querySelector('[data-gxc2-save-text]');
  var saveWasEl = root.querySelector('[data-gxc2-save-was]');
  var atcoEl    = root.querySelector('[data-gxc2-atco]');
  var mlineEl   = root.querySelector('[data-gxc2-mline]');
  var contEl    = root.querySelector('[data-gxc2-cont]');
  var arrowEl   = root.querySelector('[data-gxc2-checkout-arrow]');
  var footEl    = root.querySelector('[data-gxc2-foot]');
  var labEls    = root.querySelectorAll('[data-gxc2-labs] .gx-c2-lab');
  /* OCU-style skin (2026-08-22): the line items need the reward state to show the DISCOUNT
   * tag, and the nudge leads with a truck, as on the reference. */
  var lastReward = null;
  var TRUCK = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 3h13v13H1zM14 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';

  /* ---------- formatting ---------- */

  /* Variant titles in this catalog are not clean labels. Several carry a price baked into the
   * text that is stale AND different from what the line actually charges: Max Calm's reads
   * "1 - Gallon $113.50" against a real $134.79, Hydra-MAX's "1 - Container $99.00" against
   * $117.56. Printed raw, the cart shows a wrong price beside the right one.
   *
   * Strips from the first $ and collapses the padded dash, so "1 - Gallon $113.50" reads
   * "1 Gallon". This is cosmetic cover for a catalog problem, not a fix for it: the labels
   * themselves still need cleaning in Shopify. */
  function cleanUnit(t) {
    if (!t || t === 'Default Title') return '';
    return String(t).replace(/\s*\$[\d.,]+.*$/, '').replace(/\s+-\s+/g, ' ').trim();
  }

  function money(cents) { return '$' + (Number(cents) / 100).toFixed(2); }
  function moneyShort(cents) {
    var n = Number(cents) / 100;
    return '$' + (n % 1 === 0 ? String(n) : n.toFixed(2));
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function thumb(url, px) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + px;
  }
  function show(el, on) { if (el) el.hidden = !on; }

  var TAG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0l-7.2-7.2A2 2 0 0 1 2.8 12V4a1.2 1.2 0 0 1 1.2-1.2h8a2 2 0 0 1 1.4.6l7.2 7.2a2 2 0 0 1 0 2.8Z"/><circle cx="7.6" cy="7.6" r="1.3" fill="currentColor" stroke="none"/></svg>';
  var CHK = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  var BIN = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13M10 11v6M14 11v6"/></svg>';
  var CHEV = '<svg class="gx-c2-chev" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>';

  /* ------------------------------------------------------------------ *
   * REWARD MATH — unchanged from the previous build; the rule is settled.
   *
   * BASIS: original_line_price, NOT final_line_price. The Function measures
   * CartLine.cost.subtotalAmount (before discounts); original_line_price is the
   * /cart.js equivalent. `OCU Product Discount` is a LINE-level discount still
   * live on this store, and using final_line_price would let it drag the
   * one-time subtotal down and silently drop a tier.
   * ------------------------------------------------------------------ */
  function computeReward(cart) {
    var items = (cart && cart.items) || [];
    var oneTimeSubtotal = 0;
    var hasSubscription = false;

    for (var i = 0; i < items.length; i++) {
      if (items[i].selling_plan_allocation) { hasSubscription = true; continue; }
      oneTimeSubtotal += Number(items[i].original_line_price) || 0;
    }

    var current = null, next = null;
    for (var t = 0; t < TIERS.length; t++) {
      if (oneTimeSubtotal >= TIERS[t].min) current = TIERS[t];
      else if (!next) next = TIERS[t];
    }

    return {
      oneTimeSubtotal: oneTimeSubtotal,
      hasSubscription: hasSubscription,
      current: current,
      next: next,
      remaining: next ? next.min - oneTimeSubtotal : 0,
      /* WHOLE CENTS, and byte-identical to the Function.
         order-discount-onetime/src/cart_lines_discounts_generate_run.js computes
           discountAmountCents = Math.round((eligibleCents * percentage) / 100)
         and its header requires this line to match it exactly, so the drawer's number
         and the charged number are the SAME number rather than two independent
         roundings that agree most of the time. The previous form here was
         Math.round(cents * pct) / 100, which leaves a fractional-cent value and can
         diverge by a cent once toFixed(2) rounds it. If either formula changes, change
         both in the same commit. */
      discount: current ? Math.round((oneTimeSubtotal * current.pct) / 100) : 0
    };
  }

  /* ---------- line items ---------- */

  function renderLine(it, mode) {
    var sub = !!it.selling_plan_allocation;
    var img = it.image
      ? '<img class="is-fit" src="' + esc(thumb(it.image, 200)) + '" alt="" width="56" height="56" loading="lazy">'
      : esc((it.product_title || '').slice(0, 12));

    /* Size sits inline after the name; the category line goes underneath.
     *
     * QUANTITY APPEARS ON BOTH PATHS. This was subscription-only, on the reasoning that the
     * one-time path's stepper already shows the number. Doug corrected that on 2026-08-04
     * looking at a real cart: four gallons rendered as "Gut X - 1 Gallon" beside $539.16, and
     * the label contradicting the count is what the eye lands on, whatever the stepper says
     * an inch below. The stepper answers "how many am I buying", the label has to answer
     * "how much product is this", and "1 Gallon" was the wrong answer to both.
     *
     * Reads "4 × 1 Gallon". Not "4 Gallons", which would mean parsing and pluralising units
     * that are not consistent across this catalog ("1 Gallon", "2 Gallons", "1 - Container")
     * and would quietly mislead on any variant that is not singular. */
    var unit = cleanUnit(it.variant_title);
    var sizeText = unit;
    if (it.quantity > 1) {
      sizeText = unit ? (it.quantity + ' × ' + unit) : ('× ' + it.quantity);
    }
    /* OCU-style (2026-08-22): the variant sits on its own line under the name. */
    var size = sizeText ? '<div class="gx-c2-var">' + esc(sizeText) + '</div>' : '';

    var body = '<div class="gx-c2-nm">' + esc(it.product_title) + '</div>' + size;

    /* NO STEPPER OR REMOVE ON THE SUBSCRIPTION PATH, and that is correct.
     *
     * It looks "locked" next to the one-time path, and I proposed adding them. Doug's ruling,
     * 2026-08-04: the customer chose quantity and plan on the PRODUCT page moments earlier.
     * The drawer is a confirmation step, not a second configurator, and re-asking a question
     * they have already answered adds weight for a case that barely occurs. Anyone who does
     * want to change it has "View full cart & add more" in the header. Do not add steppers
     * here without a measured reason. */
    var stepper = '<div class="gx-c2-stepper">'
      +   '<button type="button" data-gxc2-dec aria-label="Decrease quantity">&minus;</button>'
      +   '<span class="q" data-gxc2-qty>' + it.quantity + '</span>'
      +   '<button type="button" class="is-plus" data-gxc2-inc aria-label="Increase quantity">+</button>'
      + '</div>';

    if (sub) {
      var plan = it.selling_plan_allocation.selling_plan || {};
      body += '<div class="gx-c2-sub">Subscribe &amp; Save</div>'
            + '<div class="gx-c2-meta">' + esc(plan.name || 'Subscription') + '</div>';
    } else {
      /* DISCOUNT tag under the variant when a reward tier is earned, as on the OCU reference. */
      if (mode !== 'sub' && lastReward && lastReward.current) body += '<div class="gx-c2-ltag">' + TAG + 'DISCOUNT</div>';
      body += stepper;
    }

    /* Strikethrough compare-at beside the price, and a red "$X Savings" line under it, on both
     * paths, only when there is a real saving to show (OCU-style, 2026-08-22). */
    var saving = Number(it.original_line_price) - Number(it.final_line_price);
    var was = saving > 0 ? '<s class="gx-c2-was">' + money(it.original_line_price) + '</s>' : '';
    var saveLine = saving > 0 ? '<div class="gx-c2-lsave">' + money(saving) + ' Savings</div>' : '';
    var priceBlock = '<div class="gx-c2-prw">' + was + '<b class="gx-c2-pr">' + money(it.final_line_price) + '</b></div>' + saveLine;

    var rail = sub
      ? priceBlock
      : '<button type="button" class="gx-c2-del" data-gxc2-rm aria-label="Remove ' + esc(it.product_title) + '">' + BIN + '</button>'
        + priceBlock;

    return '<div class="gx-c2-item" data-key="' + esc(it.key) + '">'
      +      '<div class="gx-c2-th">' + img + '</div>'
      +      '<div class="gx-c2-bd">' + body + '</div>'
      +      '<div class="gx-c2-rt">' + rail + '</div>'
      +    '</div>';
  }

  /* ---------- reward bar ---------- */

  function renderTier(r, mode) {
    // Hidden on the subscription path, and on an empty cart where a bar at zero with nothing
    // to move it is noise.
    if (mode === 'sub' || !r.oneTimeSubtotal) {
      show(tierEl, false);
      return;
    }
    show(tierEl, true);

    /* Three states, and the middle one is the common one. Before 2026-08-04 this line only
     * ever named the shortfall, so a cart that had ALREADY earned 5% opened with
     * "You're $65.21 away from 10%" while the 5% it had won sat 550px below in the footer.
     * The first thing in the cart was what the customer had not got.
     *
     * Earned-and-more-available now leads with the win and keeps the nudge as the tail.
     * Nothing-earned-yet is unchanged: there is no win to lead with, so the shortfall IS
     * the message. Top tier is unchanged. */
    nudgeEl.innerHTML = r.next
      ? (r.current
          ? CHK + '<span><b>' + r.current.pct + '% off</b> applied. <b>' + moneyShort(r.remaining) + '</b> more for <b>' + r.next.pct + '%</b>.</span>'
          : TRUCK + '<span>You\'re <b>' + moneyShort(r.remaining) + '</b> away from <b>' + r.next.pct + '%</b> discount!</span>')
      : CHK + '<span><b>' + r.current.pct + '% discount</b> unlocked. That is the best one-time price.</span>';

    for (var i = 0; i < segEls.length; i++) {
      var lo = i ? TIERS[i - 1].min : 0;
      var hi = TIERS[i].min;
      var f = Math.max(0, Math.min(1, (r.oneTimeSubtotal - lo) / (hi - lo)));
      segEls[i].querySelector('i').style.width = (f * 100).toFixed(2) + '%';
      segEls[i].classList.toggle('is-full', f >= 1);
      if (labEls[i]) labEls[i].classList.toggle('is-on', f >= 1);
    }
  }

  /* ---------- subscription accordion rows ---------- */

  function renderRows(cart, mode) {
    if (mode !== 'sub') { rowsEl.innerHTML = ''; return; }
    var items = cart.items || [];

    var hasCoverage = false;
    for (var i = 0; i < items.length; i++) {
      if (!items[i].selling_plan_allocation) continue;
      if ((items[i].handle || '').indexOf(COVERAGE_HANDLE) === 0) hasCoverage = true;
    }

    /* NO DELIVERY TIME ROW (removed 2026-08-04).
     *
     * It rendered "Delivery every 90 days" in a 64px card sitting directly under a line item
     * that already reads "2 gallons · every 90 days". Same information, twice, 64px apart.
     * It also could not be made interactive: changing cadence means moving the line onto a
     * different selling plan, and the 60/90/120 plan ids do not exist yet (the generated map
     * carries only each product's default 90-day plan). So it was a card that repeated the
     * line above and did nothing.
     *
     * To restore it once the cadence plans are swept, it needs to come back as a real
     * accordion with working 60/90/120 chips, not as a label. A label is what was wrong. */
    var html = '';

    // Coverage is conditional on Gut X being on subscription. It is a subscriber
    // reimbursement benefit, not insurance: copy is exact and must not be paraphrased.
    /* Coverage starts CLOSED (2026-08-04). It was rendering open, which put ~60px of terms
     * prose on screen before the customer had asked for it. The headline row still states the
     * offer, "$20,000 Colic Coverage", which is the part that sells; the day-45 qualifier is
     * what people open for and now lives only inside. */
    if (hasCoverage) {
      html += '<div class="gx-c2-row" data-gxc2-row>'
        +   '<button type="button" class="gx-c2-rowbtn" data-gxc2-rowtoggle>'
        +     '<div><div class="gx-c2-rl">Included with subscription</div>'
        /* Headline carries the OFFER only. The qualifiers (enrollment form, 30-day qualifying
         * period per the Program Terms) live in the expandable below, which is where someone
         * goes to find out what the catch is. Leading with them made the row read as a
         * restriction rather than an inclusion. */
        +     '<div class="gx-c2-rv">$20,000 Colic Coverage</div></div>' + CHEV
        +   '</button>'
        +   '<div class="gx-c2-rowbody gx-c2-rowbody--prose">'
        +     '<p>Enrollment form + a qualifying subscription. Reimbursement eligibility begins '
        +     'after a 30-day qualifying period from acceptance. Terms apply.</p>'
        +   '</div>'
        + '</div>';
    }
    rowsEl.innerHTML = html;
  }


  /* ---------- cross-sell ---------- */

  var productCache = {};
  function getProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { productCache[handle] = p; return p; })
      .catch(function () { return null; });
  }

  /* Slot 2 is always this, by Doug's call. Canonical handle, see the catalog naming note:
   * resolve by handle here only because the drawer has no SKU to hand. */
  var SECOND_PICK = 'max_calm';

  /* subtitleHtml is inserted RAW and must already be safe. CATS values carry their own
   * entities (&amp;), so running them through esc() here would double-encode and print
   * "Focus &amp; Temperament" on screen. Callers escape anything customer-derived. */
  function alsoCard(p, variantId, priceCents, subtitleHtml) {
    /* width/height are load-bearing, not decoration: with width:auto and no attributes the
     * image has a 0x0 box until it loads, so the lazy observer never fires and it never
     * loads. Two small images on a drawer the customer just opened, so they are fetched
     * eagerly rather than lazily. */
    var img = p.featured_image
      ? '<img class="is-fit" src="' + esc(thumb(p.featured_image, 400)) + '" alt="" width="120" height="92" decoding="async">'
      : esc(p.title.slice(0, 12));
    return '<div class="gx-c2-card">'
      +      '<div class="gx-c2-cth">' + img + '</div>'
      +      '<div class="gx-c2-cnm">' + esc(p.title) + '</div>'
      +      (subtitleHtml ? '<div class="gx-c2-csub">' + subtitleHtml + '</div>' : '')
      +      '<div class="gx-c2-cpr">' + money(priceCents) + '</div>'
      +      '<button type="button" class="gx-c2-cadd" data-gxc2-add="' + variantId + '">Add</button>'
      +    '</div>';
  }

  /* TWO-UP CARDS (2026-08-04). Replaces the single full-width row, in the layout Doug says
   * performed best in the OCU era: image, name, price, full-width Add, two across.
   *
   * SLOT 1 IS THE CART'S OWN PRODUCT, not a suggestion. The easiest yes is one more of the
   * thing they already chose, and on this cart it is also the shortest route up the reward
   * ladder: one more gallon takes $134.79 to $269.58 and crosses the 10% tier. Its Add reuses
   * the variant ALREADY IN THE CART (line.variant_id), so it increments that line instead of
   * opening a second one at a different size.
   *
   * SLOT 2 IS MAX CALM, fixed. If Max Calm is itself what is in the cart it would collide
   * with slot 1, so it falls back to the affinity list (PAIRS, then RECS).
   *
   * Heading is "Add to your order", not "You may also like". Slot 1 is something they have
   * already chosen, so "also like" would be describing their own cart back at them. */
  function renderAlso(cart, mode) {
    var items = (cart && cart.items) || [];
    if (mode === 'sub' || !items.length) { alsoEl.innerHTML = ''; return; }

    var inCart = items.map(function (l) { return l.handle; });
    var line = items[0];

    var second = SECOND_PICK;
    if (inCart.indexOf(SECOND_PICK) > -1) {
      var cand = [];
      inCart.forEach(function (h) {
        (PAIRS[h] || []).forEach(function (x) { if (cand.indexOf(x) < 0) cand.push(x); });
      });
      RECS.forEach(function (h) { if (cand.indexOf(h) < 0) cand.push(h); });
      second = cand.filter(function (h) { return inCart.indexOf(h) < 0; })[0] || null;
    }

    Promise.all([getProduct(line.handle), second ? getProduct(second) : null]).then(function (ps) {
      var own = ps[0], other = ps[1];
      var cards = '';

      if (own) {
        /* Their own size, so the card reads as one more of exactly what they picked. No
         * quantity multiplier here: this card sells ONE more unit whatever is already in the
         * cart, so it must show the unit price and the unit size. */
        cards += alsoCard(own, line.variant_id, line.price, esc(cleanUnit(line.variant_title)));
      }
      if (other && other.available) {
        var v = (other.variants || []).filter(function (x) { return x.available; })[0] || (other.variants || [])[0];
        if (v) cards += alsoCard(other, v.id, v.price, CATS[other.handle] || '');
      }

      alsoEl.innerHTML = cards
        ? '<h3>You may also like...</h3><div class="gx-c2-cards">' + cards + '</div>'
        : '';
    });
  }

  /* ---------- footer ---------- */

  function renderFoot(cart, r, mode) {
    var items = cart.items || [];
    if (!items.length) { show(footEl, false); return; }
    show(footEl, true);

    var retail = 0, paid = 0;
    for (var i = 0; i < items.length; i++) {
      retail += Number(items[i].original_line_price) || 0;
      paid   += Number(items[i].final_line_price) || 0;
    }

    if (mode === 'sub') {
      show(discEl, false);
      show(shipEl, false);
      totLblEl.textContent = 'Estimated total';
      totValEl.textContent = money(cart.total_price) + ' USD';
      var saved = retail - paid;
      if (saved > 0) {
        var pct = Math.round((saved / retail) * 100);
        saveTxtEl.textContent = 'You\'re saving ' + money(saved) + ' (' + pct + '% off retail)';
        saveWasEl.textContent = money(retail);
        show(saveEl, true);
      } else { show(saveEl, false); }
      show(atcoEl, false);
      /* Explicit, because the one-time branch writes a two-item version of this same element
       * and either mode can follow the other without a reload (Subscribe & Save switches a
       * cart in place). Unchanged from what the subscription cart has always shown. */
      /* OCU-style (2026-08-22): no trust line, Continue Shopping on both paths, no arrow. */
      show(mlineEl, false);
      show(contEl, true);
      show(arrowEl, false);
      return;
    }

    /* ONE-TIME.
       The discount row reflects what Shopify has ACTUALLY allocated to the cart
       (cart_level_discount_applications), not a number we computed. If the automatic
       discount is live, this matches the design exactly. If it is not yet in place, we
       show what the reward unlocks at instead of asserting a total the customer will not
       be charged. Never print a discounted Total that checkout will not honour. */
    var applied = 0;
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      applied += Number(d.total_allocated_amount) || 0;
    });

    if (r.current) {
      /* Approved copy, and it matches the Function's message byte for byte so the drawer and
       * the checkout never word the same discount differently.
       *
       * No longer conditional. The Function still narrows to "off one-time items" when it has
       * excluded a subscription line, but the drawer can never reach that branch: any cart
       * holding a subscription takes the subscription path, where this row is not rendered at
       * all. One string is the honest amount of logic here. */
      var chipCopy = r.current.pct + '% off total order';
      discEl.className = 'gx-c2-line';
      discEl.innerHTML = '<span class="l">Discount <span class="gx-c2-tag" title="' + esc(chipCopy) + '">' + TAG + 'ORDER DISCOUNT</span></span>'
        + '<span class="r is-save">' + money(applied > 0 ? applied : r.discount) + '</span>';
      show(discEl, true);
    } else {
      show(discEl, false);
    }

    /* Shipping/Free row removed 2026-08-04. The trust line added to this footer earlier the
     * same day already opens with "Free shipping", so this row said it a second time about
     * 40px above it, and it was the only footer row that never changed. Free shipping is a
     * standing fact, not a line item in this order's maths, so it reads better as a trust
     * cue than as a row in a total that has a real discount above it. Kept in the markup and
     * hidden rather than deleted: nothing else references it, and this is one flag to flip if
     * shipping ever stops being free. */
    /* OCU-style (2026-08-22): the Shipping row shows, reading "Calculated at next step". */
    shipEl.innerHTML = '<span class="l">Shipping</span><span class="r is-mut">Calculated at next step</span>';
    show(shipEl, true);
    show(saveEl, false);

    /* Total vs Subtotal is the honesty hinge. Shopify has genuinely taken the money off
       only when it appears in cart_level_discount_applications. If it has, this is a
       Total. If the reward is earned but unallocated, the figure above is still the full
       basket, so it is a Subtotal with the discount labelled as applied at checkout.
       Never print a Total the cart cannot honour. */
    var honoured = applied > 0;
    totLblEl.textContent = 'Estimated total';
    /* No " USD" suffix. Single-currency US store, so it named the only currency on offer
     * and read as noise on the largest figure in the drawer. The Total/Subtotal label
     * above already carries the meaning the suffix was doing nothing to help. */
    totValEl.textContent = money(cart.total_price) + ' USD';
    show(atcoEl, !honoured && !!r.current);

    /* Trust line on the one-time path too (2026-08-04). It was subscription-only, which left
     * the FAILING path with no risk reassurance while the converting one had it.
     *
     * "Cancel anytime" is dropped here: there is nothing to cancel on a one-time order, and a
     * guarantee that does not apply reads as boilerplate and cheapens the two that do. Free
     * shipping and the 90-day money-back are what de-risk a single purchase. Set explicitly
     * rather than left to the markup, because the subscription branch renders the same
     * element with three items and either state can follow the other without a reload. */
    show(mlineEl, false);
    show(contEl, true);
    show(arrowEl, false);
  }

  /* ---------- render ---------- */

  function setNavCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = '(' + n + ')';
    });
  }

  function render(cart) {
    var items = (cart && cart.items) || [];
    var reward = computeReward(cart);
    lastReward = reward;

    /* ANY subscription line puts the cart on the subscription path. Not "every line".
     *
     * The store's discount is set appliesOnSubscription:false, which does not narrow the
     * order discount to the one-time portion, it suppresses it outright on any cart holding
     * a subscription. Verified live 2026-08-04, and Doug ruled the same day to keep it:
     * a subscriber already has 20% from Recharge plus volume savings and does not need the
     * cart tier on top.
     *
     * So there is no third "mixed" state to design. Two paths, and a cart with a subscription
     * in it is the subscription path. This also stops the drawer filling a reward bar for a
     * discount checkout will never apply, which is the exact mismatch this build exists to
     * prevent. Per-line affordances still follow the LINE, not the mode: renderLine gives a
     * one-time line its stepper even here, so a one-time item in a mixed cart stays editable. */
    var mode = items.some(function (l) { return !!l.selling_plan_allocation; }) ? 'sub' : 'onetime';
    root.setAttribute('data-mode', mode);

    setNavCount(cart.item_count || 0);
    if (countEl) {
      countEl.textContent = cart.item_count || '';
      countEl.hidden = !cart.item_count;
    }

    if (!items.length) {
      linesEl.innerHTML = '';
      rowsEl.innerHTML = '';
      alsoEl.innerHTML = '';
      show(swapEl, false);
      show(emptyEl, true);
      show(addmoreEl, false);
      renderTier(reward, mode);
      renderFoot(cart, reward, mode);
      return cart;
    }

    show(emptyEl, false);
    show(addmoreEl, mode === 'sub');
    linesEl.innerHTML = items.map(function (it) { return renderLine(it, mode); }).join('');
    show(swapEl, mode === 'onetime');
    renderTier(reward, mode);
    renderRows(cart, mode);
    renderAlso(cart, mode);
    renderFoot(cart, reward, mode);
    renderEngineOffer(cart);
    return cart;
  }

  /* Apply the composition: clear what the engine can express, add back what it composed.
   *
   * Deliberately sequential and deliberately additive-last. Removing first would leave the cart
   * briefly empty, and an interrupted run that has already added is recoverable where one that
   * has already emptied is not. Anything the engine does not model (hardware, gifts, existing
   * combos) is never touched.
   *
   * Re-reads the cart and rebuilds the offer immediately before acting, so a stale button from a
   * cart that has since changed cannot fire against the wrong contents. */
  function applyEngineOffer() {
    if (root.getAttribute('data-busy') === 'true') return;
    root.setAttribute('data-busy', 'true');
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var offer = engineOffer(cart);
        if (!offer) return refresh();

        skuIndex();
        var updates = {};
        var adds = [];
        (cart.items || []).forEach(function (l) {
          var key = SKU_TO_KEY[l.sku];
          if (key && key !== '__combo__' && SKU_UNITS[l.sku]) updates[l.key] = 0;
        });
        /* RE-VALIDATE THE REBUILD. THIS IS THE ONE PATH THAT USED TO WRITE WITHOUT CHECKING.
         *
         * Three places consume the builder's output. The bundles page checks `unresolved` and
         * refuses (gx-bundle-checkout.js). engineOffer() below checks it and returns null, so no
         * offer is ever SHOWN for a composition that will not resolve. This function did not
         * check at all, and it is the only one of the three that WRITES to a real cart.
         *
         * That gap mattered because of the deliberate design two lines up: this re-reads /cart.js
         * and rebuilds immediately before acting, so a stale button cannot fire against changed
         * contents. Sound idea, but the REBUILD was never re-validated. The offer was checked
         * against the cart at quote time and then written against the cart at click time, and
         * anything that changed in between was pushed through unexamined.
         *
         * The concrete damage is silent, which is the worst kind: buildLines() still returns a
         * line when it cannot find a selling plan, it just records `plan:<key>` in `unresolved`
         * and leaves `selling_plan` off the line. Writing that converts a SUBSCRIPTION cart into
         * a one-time one, at the one-time price, with nothing on screen to say so. Every one of
         * the four mispriced add-on orders on 2026-08-08 through 08-12 had selling_plan null.
         *
         * Not proven to be their cause. But this is the only code path that writes cart lines
         * without checking, and it produces exactly that symptom, so it does not get to stay.
         *
         * Refuse the whole offer rather than part of it. A partial composition is what puts a
         * bare add-on in a cart with no base tier, which is under its own single price. */
        var blocked = null;
        Object.keys(offer.groups).forEach(function (name) {
          var grp = offer.groups[name];
          var built = window.GXBundlePreview(grp.cart, grp.mode, grp.cadence || '90');
          if (!built || built.error || (built.unresolved && built.unresolved.length)) {
            blocked = blocked || (built && (built.error || built.unresolved.join(','))) || 'build-failed';
            return;
          }
          (built.lines || []).forEach(function (line) { adds.push(line); });
        });
        if (blocked) {
          /* Leave the cart exactly as the shopper had it. They keep what they chose at the price
             they were shown; they simply do not get the upgrade offer applied. */
          console.error('[gx-cart-v2] engine offer did not resolve on rebuild, cart left unchanged:', blocked);
          return refresh();
        }
        if (!adds.length || !Object.keys(updates).length) return refresh();

        /* ADD FIRST, THEN REMOVE, and the removal MUST NOT be allowed to fail quietly.
         *
         * Add-first is deliberate: an interrupted run that has already added is recoverable,
         * one that has already emptied the cart is not.
         *
         * But it has a nastier failure than I first allowed for. If the add lands and the
         * removal does not, the shopper is holding the combo AND the singles it replaced, which
         * is double what they chose and double what they pay. So the removal is retried, and if
         * it still will not go, the combo we just added is taken back out so the cart returns to
         * exactly what the shopper had. Ending where we started is a bad outcome; ending with a
         * doubled cart is a chargeback. */
        function removeSingles(attempt) {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: updates })
          }).then(function (r) {
            if (r.ok) return true;
            if (attempt < 2) return removeSingles(attempt + 1);
            return false;
          }).catch(function () {
            return attempt < 2 ? removeSingles(attempt + 1) : false;
          });
        }

        function rollback() {
          var undo = {};
          adds.forEach(function (l) { undo[String(l.id)] = 0; });
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: undo })
          }).catch(function () {});
        }

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: adds })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () { return removeSingles(0); })
          .then(function (removed) { if (!removed) return rollback(); })
          .then(function () { return refresh(); });
      })
      .catch(function () { return refresh(); })
      .then(function () { root.removeAttribute('data-busy'); });
  }

  /* ================= PRICING ENGINE AT CART LEVEL =================
   *
   * The bundles page has always priced a cart properly. The drawer never has, so a shopper who
   * added Gut X and Osteo-MAX as separate lines paid $501.60 for contents that cost $470.25 as
   * OMGX400, and nothing on the page told them. Order EQ624265, 2026-08-10.
   *
   * This calls the SAME engine, `window.GXBundlePreview`, rather than reimplementing it. If it
   * is not on the page, everything below no-ops and the drawer behaves exactly as before.
   *
   * THREE RULES THIS HAS TO RESPECT, and each one is a way to get it wrong:
   *
   * 1. A COMBO IS ONE LINE WITH ONE CADENCE. Gut X on 120 days and Osteo-MAX on 90 cannot merge,
   *    however much cheaper it looks, because the merged line would silently re-time one of the
   *    deliveries. So the cart is grouped: one-time in its own bucket, subscriptions bucketed per
   *    cadence, and each bucket is composed independently.
   *
   * 2. THE LADDER CHANGES THE ANSWER. For an all-one-time cart the 5/10/15% order discount is
   *    real money, and collapsing lines into a combo LOWERS the subtotal, which can drop the cart
   *    a rung. $210 earns 10%; save $30 on line prices and $180 earns 5%, so the "saving" is a
   *    loss. The comparison is therefore on the after-discount total, never on line prices.
   *
   * 3. ANY SUBSCRIPTION SUPPRESSES THE LADDER ENTIRELY, including on the one-time lines. That is
   *    the store's Shopify Function (appliesOnSubscription:false) and Doug's ruling of
   *    2026-08-04, and `computeReward` above already models it. It is reused rather than
   *    reimplemented so the displayed saving cannot drift from what checkout charges.
   */
  var ENGINE_MIN_SAVING = 100;      // cents. Below a dollar it is noise, stay silent.

  /* Ask the engine for its data, never read window.GX_BUNDLE_DATA directly: that global is only
     set by the React builders, so on a product page it is undefined even though the engine is
     perfectly available. Testing for it disabled this feature everywhere without a builder. */
  function engineData() {
    return (typeof window.GXBundleData === 'function') ? window.GXBundleData() : null;
  }

  function engineReady() {
    return typeof window.GXBundlePreview === 'function' && window.GX_SKU_MAP && !!engineData();
  }

  /* sku -> product key, built from the map so it cannot drift from what the engine indexes by. */
  var SKU_TO_KEY = null;
  var SKU_UNITS = null;
  function skuIndex() {
    if (SKU_TO_KEY) return;
    SKU_TO_KEY = {}; SKU_UNITS = {};
    var prods = (window.GX_SKU_MAP && window.GX_SKU_MAP.products) || {};
    Object.keys(prods).forEach(function (key) {
      if (key === '_') return;
      var p = prods[key] || {};
      Object.keys(p.tiers || {}).forEach(function (u) {
        var t = p.tiers[u];
        if (u !== '_' && t && t.sku) { SKU_TO_KEY[t.sku] = key; SKU_UNITS[t.sku] = Number(u); }
      });
      if (p.addon && p.addon.sku) { SKU_TO_KEY[p.addon.sku] = key; SKU_UNITS[p.addon.sku] = 1; }
    });
    Object.keys((window.GX_SKU_MAP && window.GX_SKU_MAP.combos) || {}).forEach(function (sku) {
      var c = window.GX_SKU_MAP.combos[sku];
      if (sku !== '_' && c && c.items) { SKU_TO_KEY[sku] = '__combo__'; }
    });
  }

  function cadenceOf(line) {
    var a = line.selling_plan_allocation;
    if (!a || !a.selling_plan) return null;
    var m = String(a.selling_plan.name || '').match(/(\d+)/);
    return m ? m[1] : '90';
  }

  /* Split the cart into independently composable buckets, and report anything we must not touch. */
  function engineGroups(items) {
    skuIndex();
    var groups = {};                 // "one" | "sub:120" -> { cart:{key:units}, cents:0 }

    items.forEach(function (l) {
      var key = SKU_TO_KEY[l.sku];
      var units = SKU_UNITS[l.sku];
      if (!key || key === '__combo__' || !units) {
        /* Skipped, not fatal. Three kinds of line land here and none should block an offer on
           the rest of the cart:
             - a combo already in the cart. Its contents are NOT decomposed back into the pool,
               so a cart holding OMGX200 plus a loose Gut X and Osteo-MAX will not be re-cut into
               OMGX400. That is a missed saving, never a wrong one, and unpicking an existing
               combo is a bigger change than this feature should make on its own.
             - hardware and gifts, which the engine does not model at all.
             - anything whose SKU is not in the map. */
        return;
      }
      var cad = cadenceOf(l);
      var g = cad ? ('sub:' + cad) : 'one';
      groups[g] = groups[g] || { cart: {}, cents: 0, mode: cad ? 'sub' : 'one', cadence: cad };
      groups[g].cart[key] = (groups[g].cart[key] || 0) + units * l.quantity;
      groups[g].cents += Number(l.original_line_price) || 0;
    });
    return { groups: groups };
  }

  function ladderPct(oneTimeCents, hasSub) {
    if (hasSub) return 0;
    var pct = 0;
    for (var i = 0; i < TIERS.length; i++) if (oneTimeCents >= TIERS[i].min) pct = TIERS[i].pct;
    return pct;
  }

  /* Returns null when there is nothing worth saying. */
  function engineOffer(cart) {
    if (!engineReady()) return null;
    var items = (cart && cart.items) || [];
    if (!items.length) return null;

    var g = engineGroups(items);
    var keys = Object.keys(g.groups);
    if (!keys.length) return null;

    var currentCents = 0, composedCents = 0;
    for (var i = 0; i < keys.length; i++) {
      var grp = g.groups[keys[i]];
      var built;
      try { built = window.GXBundlePreview(grp.cart, grp.mode, grp.cadence || '90'); }
      catch (e) { return null; }
      // A partial composition is worse than none: a missing combo id or plan means the swap
      // would drop something out of the cart.
      if (!built || built.error || (built.unresolved && built.unresolved.length)) return null;

      /* CADENCE GUARD. The engine's planFor() is `plans[cadence] || plans['90'] || null`, so a
       * combo missing the requested cadence SILENTLY FALLS BACK TO 90 DAYS and is not reported
       * as unresolved. Left unchecked, a shopper on 120 days would be offered a swap that quietly
       * re-times their deliveries, which is the exact thing this feature is supposed to refuse.
       *
       * Every combo carries all five cadences today, so this never fires. It exists because the
       * day someone adds a combo without a 120-day plan, the failure is silent and lands on a
       * customer's subscription rather than in a console. */
      if (grp.mode === 'sub') {
        var wanted = {};
        var pm = window.GX_SKU_MAP.products || {}, cm = window.GX_SKU_MAP.combos || {};
        Object.keys(pm).forEach(function (k) {
          var pl = pm[k] && pm[k].plans; if (pl && pl[grp.cadence]) wanted[String(pl[grp.cadence])] = 1;
        });
        Object.keys(cm).forEach(function (k) {
          var pl = cm[k] && cm[k].plans; if (pl && pl[grp.cadence]) wanted[String(pl[grp.cadence])] = 1;
        });
        var wrongCadence = (built.lines || []).some(function (l) {
          return !l.selling_plan || !wanted[String(l.selling_plan)];
        });
        if (wrongCadence) return null;
      }
      var oneTime = Math.round(Number(built.actual) * 100);
      if (!isFinite(oneTime) || oneTime <= 0) return null;
      var cents = grp.mode === 'sub'
        ? Math.round(oneTime * (1 - ((engineData() || {}).sub || 0)))
        : oneTime;
      currentCents += grp.cents;
      composedCents += cents;
    }

    // Ladder on both sides, on the WHOLE cart, because untouched lines count toward it too.
    var reward = computeReward(cart);
    var hasSub = reward.hasSubscription;
    var oneTimeNow = reward.oneTimeSubtotal;
    var delta = currentCents - composedCents;
    if (delta <= 0) return null;

    var discNow = Math.round(oneTimeNow * ladderPct(oneTimeNow, hasSub) / 100);
    var oneTimeAfter = hasSub ? oneTimeNow : Math.max(0, oneTimeNow - delta);
    var discAfter = Math.round(oneTimeAfter * ladderPct(oneTimeAfter, hasSub) / 100);

    var saving = delta - (discNow - discAfter);
    if (saving < ENGINE_MIN_SAVING) return null;

    return { saving: saving, groups: g.groups };
  }

  /* WRAPPED, AND THAT IS THE POINT.
   *
   * This is called from render(), which repaints the whole drawer. A throw anywhere in the offer
   * logic would take the cart down with it: no lines, no totals, no checkout button, on every
   * page of the store. The offer is a nice-to-have; the cart is the business.
   *
   * So anything unexpected here means the drawer renders exactly as it did before this feature
   * existed. GX_SKU_MAP arriving malformed, a product key the map does not know, the engine
   * throwing internally: all of it degrades to silence rather than a broken cart. */
  function renderEngineOffer(cart) {
    try {
      renderEngineOfferInner(cart);
    } catch (e) {
      var el = root.querySelector('[data-gxc2-engine]');
      if (el) { el.innerHTML = ''; show(el, false); }
    }
  }

  /* The saving the Checkout button will apply. Held here so the click handler does not have to
     recompute, though it re-derives from the live cart before acting anyway. */
  var pendingOffer = null;

  /* THE SAVING LIVES ON THE CHECKOUT BUTTON AND NOWHERE ELSE.
   *
   * This went through three shapes. First a "Switch & save" button beside Checkout, which made
   * the money depend on noticing a secondary control. Then that button plus an explanatory row.
   * Doug cut the row 2026-08-10: with the button reading "Checkout & Save $31.35" the row was
   * saying the same thing twice, directly above it.
   *
   * So the button is the whole interface. It states the amount before the tap, and the swap runs
   * on the way to checkout, so a shopper who reads nothing still gets the cheaper price. */
  function renderEngineOfferInner(cart) {
    var label = root.querySelector('[data-gxc2-checkout-label]');
    /* PLAIN CHECKOUT (Doug, 2026-08-22). The dynamic "Checkout & Save $X" label confused
     * shoppers, so the button now always reads "Checkout" and checks out the cart exactly as
     * shown. Forcing pendingOffer to null also switches off the on-click bundle swap, so nothing
     * recomposes the cart silently on the way to checkout (see the click handler below, which
     * short-circuits straight to /checkout when pendingOffer is null). engineOffer() is left
     * defined but no longer drives the button. */
    pendingOffer = null;
    if (label) label.textContent = 'Checkout';
  }

  /* ---------- Cart AJAX ---------- */

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render);
  }

  function change(key, qty) {
    root.setAttribute('data-busy', 'true');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { return refresh(); })
      .then(function () { root.removeAttribute('data-busy'); });
  }

  function addVariant(id) {
    root.setAttribute('data-busy', 'true');
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function () { return refresh(); })
      .catch(function () {})
      .then(function () { root.removeAttribute('data-busy'); });
  }

  /* ---------- open / close ---------- */

  var prevBodyOverflow = '';
  var lastFocus = null;

  function open() {
    if (deferToOcu()) return;
    lastFocus = document.activeElement;
    if (scrim) { scrim.hidden = false; scrim.setAttribute('data-open', 'true'); }
    root.setAttribute('data-open', 'true');
    root.setAttribute('aria-hidden', 'false');
    prevBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    var closeBtn = root.querySelector('[data-gxc2-close]');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    root.setAttribute('data-open', 'false');
    root.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.setAttribute('data-open', 'false');
    document.body.style.overflow = prevBodyOverflow;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- wiring ---------- */

  if (scrim) scrim.addEventListener('click', close);
  var closeEl = root.querySelector('[data-gxc2-close]');
  if (closeEl) closeEl.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.getAttribute('data-open') === 'true') close();
  });

  /* CHECKOUT, WITH THE SAVING APPLIED ON THE WAY.
   *
   * If the pricing engine found a cheaper composition, the swap runs here and the shopper lands
   * on checkout with the cheaper cart. They never had to notice the offer row.
   *
   * THE ONE RULE: NEVER TRAP SOMEONE ON THE WAY TO CHECKOUT. A saving is worth about half a
   * second; it is not worth a checkout. So the navigation is guaranteed three ways over:
   *   - a hard 2.5s ceiling that fires regardless of what the swap is doing
   *   - the same navigation on the failure path as on the success path
   *   - a `went` latch so the two can never double-navigate
   * Worst case the shopper checks out at the price they already had, which is exactly what
   * happens today. There is no state in which this button stops working.
   *
   * The button is disabled and relabelled while it works, because a second tap on an unchanged
   * button is what people do when nothing appears to happen. */
  var checkoutBtn = root.querySelector('[data-gxc2-checkout]');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      var went = false;
      function go() {
        if (went) return;
        went = true;
        window.location.href = '/checkout';
      }
      if (!pendingOffer || typeof applyEngineOffer !== 'function') return go();

      checkoutBtn.disabled = true;
      var label = root.querySelector('[data-gxc2-checkout-label]');
      if (label) label.textContent = 'Applying your saving';

      setTimeout(go, 2500);
      try {
        var p = applyEngineOffer();
        if (p && typeof p.then === 'function') p.then(go, go); else go();
      } catch (e) { go(); }
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-open-cart]');
    if (!trigger) return;
    e.preventDefault();
    refresh().then(open);
  });

  // Qty, remove, accordions, cadence, cross-sell add — all delegated off the body so
  // re-rendered markup stays live.
  root.addEventListener('click', function (e) {
    var t = e.target;

    var toggle = t.closest && t.closest('[data-gxc2-rowtoggle]');
    if (toggle) { toggle.closest('[data-gxc2-row]').classList.toggle('is-open'); return; }

    var add = t.closest && t.closest('[data-gxc2-add]');
    if (add) { addVariant(add.getAttribute('data-gxc2-add')); return; }


    var item = t.closest && t.closest('.gx-c2-item');
    if (!item) return;
    var key = item.getAttribute('data-key');
    var qEl = item.querySelector('[data-gxc2-qty]');
    var qty = qEl ? (Number(qEl.textContent) || 1) : 1;
    if (t.closest('[data-gxc2-inc]')) change(key, qty + 1);
    else if (t.closest('[data-gxc2-dec]')) change(key, Math.max(0, qty - 1));
    else if (t.closest('[data-gxc2-rm]')) change(key, 0);
  });

  /* Subscribe & Save. Moves every eligible one-time line onto its product's subscription
   * plan, in place.
   *
   * Plan ids come from /products/{handle}.js, NOT from a generated map. There is a map at
   * app/checkout-extensions/shared/sellingPlans.generated.js, but it is a July snapshot and
   * a stale plan id here would either fail or, worse, subscribe someone to the wrong cadence.
   * The product JSON is the live truth and is already cached by the cross-sell lookup.
   *
   * Re-reads the cart every pass because CHANGING A LINE'S SELLING PLAN CHANGES ITS KEY.
   * Iterating a captured list would work on the first line and then silently miss the rest.
   * The pass counter is a stop against a line that will not convert spinning forever. */
  function switchToSubscription() {
    root.setAttribute('data-busy', 'true');
    var passes = 0;

    function step() {
      if (passes++ > 12) return Promise.resolve();
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var line = (cart.items || []).filter(function (l) { return !l.selling_plan_allocation; })[0];
          if (!line) return null;
          return getProduct(line.handle).then(function (p) {
            var group = p && p.selling_plan_groups && p.selling_plan_groups[0];
            var plans = (group && group.selling_plans) || [];
            /* 90 days is the default cadence, not plans[0]. The groups come back in the
             * order Recharge defines them, which puts 30 days first, so taking the first
             * plan silently subscribes everyone to the shortest interval and the most
             * frequent charge. Match on 90 and fall back to the first plan only when a
             * product genuinely has no 90-day option. Same convention the generated map
             * uses: "90 days, falling back to the first available plan when 90 is absent". */
            var plan = plans.filter(function (sp) {
              return /\b90\b/.test(sp.name || '');
            })[0] || plans[0];
            // No plan for this product: leave it one-time rather than failing the whole switch.
            if (!plan) { line.__skip = true; return null; }
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                id: line.key,
                quantity: line.quantity,
                selling_plan: plan.id
              })
            }).then(step);
          });
        });
    }

    return step()
      .catch(function () {})
      .then(function () {
        root.removeAttribute('data-busy');
        return refresh();
      });
  }

  var swapBtn = root.querySelector('[data-gxc2-swap-btn]');
  if (swapBtn) swapBtn.addEventListener('click', switchToSubscription);

  /* Delegated, because the offer is written into the drawer on every repaint and a direct
     listener would be lost the moment it re-renders. */
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-gxc2-engine-apply]')) applyEngineOffer();
  });

  /* ---------- add from the buy box ---------- */

  /* TWO PAYLOAD SHAPES. The second one was added 2026-08-11 to fix a silent dead button.

       single   d.variantId  (+ d.sellingPlanId)      every single-product buy box
       multi    d.lines = [{ id, quantity, selling_plan }, ...]

     WHAT WENT WRONG. The OM+GX combo adds TWO real product lines rather than one combo
     variant, so it cannot express itself as a single variantId. omgx-v1.js dispatched
     `items` (handles and counts) instead. This listener returned on the missing
     variantId, and omgx-v1.js then skipped its own fallback fetch because
     __gxCartModule was set. Both paths declined, silently, with no console error, and
     mobile Add to Cart on /pages/osteo-gut added nothing at all.

     THE SINGLE-VARIANT BRANCH BELOW IS UNCHANGED. Every existing caller behaves exactly
     as before; `lines` is purely additive.

     DO NOT "FIX" A FUTURE CALLER BY GIVING IT ITS OWN fetch TO /cart/add.js. Everything
     downstream of this point is shared on purpose: the first-subscription GWP gift, the
     OCU deferral, the drawer refresh and the drawer open. A caller that dodges this
     listener loses all four and nothing anywhere reports it. Add a payload shape here
     instead, the way this one was added. */
  window.addEventListener('gx:add-to-cart', function (e) {
    var d = e.detail || {};

    var items = [];

    if (Array.isArray(d.lines) && d.lines.length) {
      for (var i = 0; i < d.lines.length; i++) {
        var L = d.lines[i];
        if (!L || !L.id) continue;
        var multi = { id: Number(L.id), quantity: Number(L.quantity) || 1 };
        if (L.selling_plan) multi.selling_plan = Number(L.selling_plan);
        items.push(multi);
      }
    } else if (d.variantId) {
      var line = { id: Number(d.variantId), quantity: Number(d.quantity) || 1 };
      if (d.sellingPlanId) line.selling_plan = Number(d.sellingPlanId);
      items.push(line);
    }

    if (!items.length) return;

    /* GWP is keyed off d.sellingPlanId and d.tier, which only the single-variant shape
       carries, so a multi-line subscription does NOT currently attach a gift. That is
       flagged rather than fixed here: the GWP rule is once per customer PER PRODUCT and
       deciding what a two-product subscription earns is a business call, not a cart
       refactor. */
    if (d.sellingPlanId && window.GX_GIFT && window.GX_GIFT[String(d.tier || '')]) {
      items.push({ id: Number(window.GX_GIFT[String(d.tier)]), quantity: 1 });
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .then(function () {
        if (deferToOcu()) {
          window.dispatchEvent(new CustomEvent('ocu:cart:open:updated'));
          return;
        }
        open();
      })
      .catch(function () {});
  });

  refresh();
})();
